import React from "react";

const Shimmer = ({ width, height = 12, radius = 6 }) => (
  <span className="nt-shimmer" style={{ width, height, borderRadius: radius }} />
);

const WIDTHS = ["68%", "82%", "54%", "76%", "62%"];

export const NotificationRowSkeleton = ({ width = "70%" }) => (
  <li className="nt-row nt-row-skeleton" aria-hidden="true">
    <span className="nt-row-hit">
      <Shimmer width={40} height={40} radius={13} />

      <span className="nt-row-body">
        <Shimmer width={width} height={15} />
        <Shimmer width="46%" />
        <Shimmer width={90} height={10} />
      </span>
    </span>
  </li>
);

export const NotificationListSkeleton = ({ rows = 5 }) => (
  <ul className="nt-list" aria-hidden="true">
    {Array.from({ length: rows }).map((unused, index) => (
      <NotificationRowSkeleton key={index} width={WIDTHS[index % WIDTHS.length]} />
    ))}
  </ul>
);

export default NotificationListSkeleton;
